import React, { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import styles from './Hero.module.css';

export default function Hero() {
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.playbackRate = 0.75;
    }
  }, []);

  const containerVariants = {
    hidden: {},
    visible: { transition: { staggerChildren: 0.18 } },
  };

  const lineVariants = {
    hidden: { y: 60, opacity: 0 },
    visible: { y: 0, opacity: 1, transition: { duration: 1, ease: [0.25, 0.46, 0.45, 0.94] } },
  };

  const fadeIn = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.9, ease: [0.25, 0.46, 0.45, 0.94] } },
  };

  return (
    <section id="hero" className={styles.hero}>
      {/* Background video */}
      <div className={styles.videoBg}>
        <video
          ref={videoRef}
          autoPlay
          muted
          loop
          playsInline
          className={styles.video}
        >
          <source src={require('../../assets/work3.mp4')} type="video/mp4" />
        </video>
        <div className={styles.videoOverlay} />
      </div>

      {/* Content */}
      <div className={styles.content}>
        <motion.div
          className={styles.tagline}
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
        >
          <span className={styles.taglineLine} />
          <span>Vancouver, Canada</span>
        </motion.div>

        <motion.div
          className={styles.headingWrap}
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          <div className={styles.overflowHide}>
            <motion.h1 className={styles.heroTitle} variants={lineVariants}>
              Art That Lives
            </motion.h1>
          </div>
          <div className={styles.overflowHide}>
            <motion.h1 className={`${styles.heroTitle} ${styles.heroTitleItalic}`} variants={lineVariants}>
              on Every Surface
            </motion.h1>
          </div>
        </motion.div>

        <motion.p className={styles.heroSub} variants={fadeIn} initial="hidden" animate="visible" transition={{ delay: 0.9 }}>
          Murals · Canvas · Textile · Commissioned Works
        </motion.p>

        <motion.div
          className={styles.heroCta}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 1.1 }}
        >
          <a
            href="#portfolio"
            className={styles.ctaPrimary}
            onClick={e => { e.preventDefault(); document.querySelector('#portfolio').scrollIntoView({ behavior: 'smooth' }); }}
          >
            View Work
          </a>
          <a
            href="https://bookanartist.co/artist/artist-for-hire/13184"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.ctaSecondary}
          >
            Book a Project
          </a>
        </motion.div>
      </div>

      {/* Scroll indicator */}
      <motion.div
        className={styles.scrollIndicator}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.6, duration: 1 }}
      >
        <div className={styles.scrollLine} />
        <span>Scroll</span>
      </motion.div>
    </section>
  );
}
